import {
  MaterialDateConfirmationMilestone,
  ProjectCalendarOffs
} from "../types";
import MilestoneTimelineCard from "./milestone-timeline-card";

function ActiveTimelineItem({
  milestone,
  previousMilestone,
  timezoneId,
  calendarOffs,
  canMarkComplete,
  projectedDateLabel,
  disableSetActualDate,
  hasProjectedDateError = false,
  hasActualDateError = false,
  onProjectedDateChange,
  onCompletedDateChange,
  onMarkCompleteChange
}: {
  milestone: MaterialDateConfirmationMilestone;
  previousMilestone?: MaterialDateConfirmationMilestone;
  timezoneId: string;
  calendarOffs?: ProjectCalendarOffs;
  canMarkComplete: boolean;
  projectedDateLabel?: string;
  disableSetActualDate?: boolean;
  hasProjectedDateError?: boolean;
  hasActualDateError?: boolean;
  onProjectedDateChange: (date: string | null) => void;
  onCompletedDateChange: (date: string | null) => void;
  onMarkCompleteChange: (isComplete: boolean) => void;
}) {
  return (
    <MilestoneTimelineCard
      milestone={milestone}
      dataTestId={`active-timeline-item-${milestone.id}`}
      timezoneId={timezoneId}
      calendarOffs={calendarOffs}
      isTitleBold
      previousMilestone={previousMilestone}
      canMarkComplete={canMarkComplete}
      projectedDateLabel={projectedDateLabel}
      disableSetActualDate={disableSetActualDate}
      hasProjectedDateError={hasProjectedDateError}
      hasActualDateError={hasActualDateError}
      onProjectedDateChange={onProjectedDateChange}
      onCompletedDateChange={onCompletedDateChange}
      onMarkCompleteChange={onMarkCompleteChange}
    />
  );
}

export default ActiveTimelineItem;
